export const selectVariant = (parameters, variants) => {
  if (!variants || !variants.length) return null;

  return variants.find((variant) => {
    if (!variant.option_values || !variant.option_values.length) return false;

    return variant
      .option_values
      .every((optionValue) => parameters[optionValue.option_type_name] === optionValue.name);
  });
};
